import React from "react";

import HalfLayout from "components/HalfLayout";
import AnalysisLayout from "./components/AnalysisLayout";
import PdfViewerLayout from "./components/PdfViewerLayout";

function Analysis() {
  return (
    <HalfLayout
      leftComponent={<AnalysisLayout />}
      rightComponent={<PdfViewerLayout />}
    />
  );
}

export default Analysis;
